<p-dialog 
  [(visible)]="visible" 
  [modal]="true"
  [style]="style"
  [contentStyle]="contentStyle"
  (onHide)="close.emit()">
  
  <div class="upload-modal-content">
    <!-- Header -->
    <div class="modal-header" *ngIf="showCloseButton">
      <button class="close-button" (click)="close.emit()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Steps -->
    <div class="steps-container">
      <div class="step-indicators">
        <ng-container *ngFor="let step of steps; let i = index">
          <div class="step" [class.active]="activeStep >= i">
            <div class="step-number">{{step.number}}</div>
            <div class="step-label">{{step.label}}</div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Content -->
    <div class="step-content">
      <ng-container [ngSwitch]="uploadStatus.state">
        <!-- Upload Steps -->
        <ng-container *ngSwitchCase="'idle'">
          <ng-content></ng-content>
        </ng-container>

        <!-- Upload Progress -->
        <div *ngSwitchCase="'uploading'" class="upload-status">
          <div class="status-icon">
            <i class="pi pi-spin pi-spinner"></i>
          </div>
          <h3>Uploading...</h3>
          <p-progressBar [value]="uploadProgress"></p-progressBar>
          <div class="progress-label">{{uploadProgress}}% Complete</div>
        </div>

        <!-- Success State -->
        <div *ngSwitchCase="'success'" class="upload-status">
          <div class="status-icon success">
            <i class="pi pi-check-circle"></i>
          </div>
          <h3>Upload Successful!</h3>
          <p>{{uploadStatus.message}}</p>
        </div>

        <!-- Error State -->
        <div *ngSwitchCase="'error'" class="upload-status">
          <div class="status-icon error">
            <i class="pi pi-times-circle"></i>
          </div>
          <h3>Upload Failed</h3>
          <p>{{uploadStatus.message}}</p>
          <p class="error-details">{{uploadStatus.error?.message}}</p>
          <p-button label="Try Again" (click)="retry.emit()"></p-button>
        </div>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <p-button 
        *ngIf="showBackButton()"
        label="Back" 
        icon="pi pi-chevron-left" 
        (click)="onBackClick($event)" 
        [disabled]="isBackButtonDisabled()"
        styleClass="p-button-text">
      </p-button>
      <p-button 
        [label]="primaryButtonLabel"
        [icon]="getNextIcon()"
        iconPos="right"
        (click)="finish.emit()"
        [disabled]="!canProceed || uploadStatus.state === 'uploading'"
        styleClass="p-button-primary">
      </p-button>
    </div>
  </div>
</p-dialog> 